module.exports = __webpack_public_path__ + "img/team.74f9ba45.jpg";